import { CardContainer } from './Card.styles';

export type CardProps = {
  children: React.ReactNode;
  height?: string;
  isBorderless?: boolean;
  width?: string;
};

export const Card = ({ children, height, isBorderless = true, width }: CardProps) => {
  return (
    <CardContainer $height={height} $isBorderless={isBorderless} $width={width}>
      {children}
    </CardContainer>
  );
};
